import FormConfig from "./ConfigurationFormConfig";

export default class RainwaterSelectionMap {

	constructor() {
		$(FormConfig.selectors.rainwaterMapLoading).show();
		this.container = $('#weatherStationMap');
		this.gridFeatures = {};
		this.highlightLayer = null;
		this.rcIndexField = $(FormConfig.selectors.rcIndexInput);
		this.rcIndexOutput = $(FormConfig.selectors.rcIndexOutput);
		this.initialZoom = 12;

		this.show();

		this.map = L.map('weatherStationMap', {
			zoomControl: true,
			boxZoom: true,
			doubleClickZoom: true,
			dragging: true,
			scrollWheelZoom: true,
			touchZoom: true,
			maxZoom: 14,
			minZoom: 11
		}).fitBounds([[53.969012350740314, 14.963378906250002], [48.47292127248785, 6.174316406250001]]);
		this.map.zoomControl.setPosition('bottomright');
		this.map.attributionControl.setPrefix('<a href="https://www.bkg.bund.de" target="_blank">www.bkg.bund.de</a> &middot; <a href="https://github.com/tomchadwin/qgis2web" target="_blank">qgis2web</a> &middot; <a href="https://leafletjs.com" title="A JS library for interactive maps">Leaflet</a> &middot; <a href="https://qgis.org">QGIS</a>');
		this.map.attributionControl.setPosition('bottomleft');
		var bounds_group = new L.featureGroup([]);
		this.map.createPane('pane_TopPlusOpenGraustufen_0');
		this.map.getPane('pane_TopPlusOpenGraustufen_0').style.zIndex = 400;
		var layer_TopPlusOpenGraustufen_0 = L.WMS.layer("https://sgx.geodatenzentrum.de/wms_topplus_open", "web", {
			pane: 'pane_TopPlusOpenGraustufen_0',
			format: 'image/png',
			uppercase: true,
			transparent: true,
			continuousWorld: true,
			tiled: true,
			info_format: 'text/html',
			opacity: 1,
			identify: false,
			attribution: '',
		});
		this.map.addLayer(layer_TopPlusOpenGraustufen_0);

		this.map.createPane('pane_KOSTRADWD2020Raster_1');
		this.map.getPane('pane_KOSTRADWD2020Raster_1').style.zIndex = 401;
		this.map.getPane('pane_KOSTRADWD2020Raster_1').style['mix-blend-mode'] = 'normal';
		var layer_KOSTRADWD2020Raster_1 = new L.geoJson(json_KOSTRADWD2020Raster_1, {
			attribution: '',
			interactive: true,
			dataVar: 'json_KOSTRADWD2020Raster_1',
			layerName: 'layer_KOSTRADWD2020Raster_1',
			pane: 'pane_KOSTRADWD2020Raster_1',
			onEachFeature: (feature, layer) => this.pop_KOSTRADWD2020Raster_1(feature, layer),
			style: (feature) => this.style_KOSTRADWD2020Raster_1_0(feature),
		});

		const abstract = new L.Control({'position': 'topright'});
		abstract.onAdd = () => {
			this.div = L.DomUtil.create('div', 'leaflet-control abstract');
			this.div.id = 'abstract'
			this.div.innerHTML = '<img src="/fileadmin/dwd-logo.png" />'
			return this.div;
		}
		abstract.addTo(this.map);

		this.map.on('layeradd', () => {
			$(FormConfig.selectors.rainwaterMapLoading).hide();
		});

		bounds_group.addLayer(layer_KOSTRADWD2020Raster_1);
		this.map.addLayer(layer_KOSTRADWD2020Raster_1);

		this.hide();
	}

	pop_KOSTRADWD2020Raster_1(feature, layer) {
		layer.on({
			mouseout: e => {
				if (e.target !== this.selectedFeature) {
					this.resetStyle(e.target);
				}
			},
			mouseover: e => this.highlightFeature(e),
			click: e => this.selectFeature(e)
		});
		this.gridFeatures[feature.properties.INDEX_RC] = layer;
	}

	style_KOSTRADWD2020Raster_1_0(feature) {
		return {
			pane: 'pane_KOSTRADWD2020Raster_1',
			opacity: 1,
			color: 'rgba(53,121,177,1.0)',
			dashArray: '',
			lineCap: 'square',
			lineJoin: 'bevel',
			weight: 4.0,
			fillOpacity: 0,
			interactive: true,
		}
	}

	getFeatureLatLng(INDEX_RC) {
		const layer = this.gridFeatures[INDEX_RC],
			featureCoordinates = layer.feature.geometry.coordinates[0][0];
		// get center coordinates
		return [
			featureCoordinates[0][1] + ((featureCoordinates[2][1] - featureCoordinates[0][1]) / 2),
			featureCoordinates[0][0] + ((featureCoordinates[2][0] - featureCoordinates[0][0]) / 2),
		];
	}

	flyToGridFeature(INDEX_RC) {
		this.map.flyTo(this.getFeatureLatLng(INDEX_RC), this.initialZoom);
	}

	setViewToGridFeature(INDEX_RC) {
		this.map.setView(this.getFeatureLatLng(INDEX_RC), this.initialZoom);
	}

	updateRcIndex(rcIndex) {
		this.rcIndexField.val(rcIndex);
		this.rcIndexOutput.parent().show();
		/* Split rcIndex into row + column */
		let rcIndexOutput = 'Z' + rcIndex.slice(0, -3) + ' S' + rcIndex.slice(-3)
		this.rcIndexOutput.html(rcIndexOutput);
	}

	highlightFeature(e) {
		if(e.target === this.selectedFeature) {
			return;
		}

		this.highlightLayer = e.target;

		this.highlightLayer.setStyle({
			fillColor: '#3179ff',
			fillOpacity: 0.3
		});
	}

	selectFeature(e) {
		this.updateRcIndex(e.target.feature.properties.INDEX_RC);

		if (this.selectedFeature) {
			this.resetStyle(this.selectedFeature);
		}

		this.selectedFeature = e.target;

		this.selectedFeature.setStyle({
			fillColor: '#3179ff',
			fillOpacity: 0.5
		});
	}

	selectByRcIndex(rcIndex) {
		this.selectFeature({target: this.gridFeatures[rcIndex]});
	}

	resetStyle(feature) {
		feature.setStyle({
			fillColor: '#3179ff',
			fillOpacity: 0
		});
	}

	hide() {
		this.container.hide();
		console.log('hide');
	}

	show() {
		this.container.show();
		console.log('show');
	}
}
